import React from 'react';
import { useTranslation } from 'react-i18next';
import { KycFormRenderer } from './../../lib/kyc-form-renderer/index.js';

function KycStepPreview({ fields, countries = [] }) {
  const { t } = useTranslation();

  return (
    <KycFormRenderer
      fields={fields}
      countries={countries}
      containerClassName="border rounded p-3 app-kyc-preview"
      showHeader
      headerText={t('kyc.formPreview')}
      emptyText={t('kyc.noFieldsConfigured')}
    />
  );
}

export default KycStepPreview;
